import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useLocation, useParams } from 'react-router-dom';
import HeaderSection from '../../components/reusableComponents/HeaderSection';
import { verifyAccountDispatch } from '../../reducers/UserReducer';
// function useQuery() {
// 	const { search } = useLocation();

// 	return React.useMemo(() => new URLSearchParams(search), [search]);
// }
const PaymentVerify = () => {
	// let query = useQuery();
	const dispatch = useDispatch();
	const history = useHistory();
	const { loadinguser, verify } = useSelector((state) => state.user);
	// console.log(query.get('validationString'));

	return (
		<>
			<HeaderSection />
			<div
				style={{
					position: 'fixed',
					top: 0,
					left: 0,
					width: '100%',
					height: '100%',
					backgroundColor: '#F8F8F8AD',
				}}>
				<div
					style={{
						left: '20%',
						top: '50%',
						zIndex: 1000,
						position: 'absolute',
					}}>
					
						<div style={{ fontSize: 35 }}>please wait.....</div>
				
				</div>
			</div>
		</>
	);
};

export default PaymentVerify;
